export const EXTERNAL_LINKS = {
  homepage: {
    url: "https://invest-aitech.com",
    label: "invest_aitech",
  },
  qiita: [
    {
      url: "https://qiita.com/invest-aitech/items/450163ab642f5acbefa4",
      title: "PPTX 解析 (v01) — Qiita",
      summary: "PPTX を Python で構造化・解析する基本アプローチ",
    },
    {
      url: "https://qiita.com/invest-aitech/items/a460b55c03a9ef5a85c6",
      title: "PPTX 解析 (v02) — Qiita",
      summary: "テンプレート駆動生成と骨子 LLM の実践記",
    },
  ],
} as const;
